import React, { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import LhicModal from './LhicModal'

const navItems = [
  { to: '/about', label: 'About us' },
  { to: '/membership', label: 'Membership' },
  { to: '/donation', label: 'Donation' },
  { to: '/project', label: 'Vision & Mission' },
]

function closeMobileMenu() {
  const toggle = document.getElementById('ackapa')
  if (toggle) toggle.checked = false
}

export default function Navbar() {
  const [logoError, setLogoError] = useState(false)
  const [lhicOpen, setLhicOpen] = useState(false)

  return (
    <div className="header-wrapper header-position">
      <header id="header" className="container-header type1">
        <div className="top-nav">
          <div className="container">
            <div className="row">
              <div className="top-left col-sm-6 hidden-xs">
                <ul className="list-inline" />
              </div>
              <div className="top-right col-sm-6 col-xs-12">
                <ul className="list-inline">
                  <li className="top-search" />
                  <li className="login">
                    <Link to="/contactus">Contact us</Link>
                  </li>
                  <li className="login">
                    <Link to="/register">Registration</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="header-middle">
          <div className="containerm litaana-header-bar">
            <button
              type="button"
              className="litaana-powered-by hidden-xs hidden-sm"
              onClick={() => setLhicOpen(true)}
            >
               <span className="litaana-powered-by__brand">Loksarang Hardas Incubation Centre</span>
            </button>

            <div className="logo litaana-logo-wrap hidden-sm hidden-xs">
              <Link to="/" className="litaana-logo-link">
                {!logoError ? (
                  <img
                    id="litaana-header-logo"
                    src="images/newlogo.png"
                    alt="LITAANA"
                    className="litaana-logo-img"
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <span className="litaana-logo-text">LITAANA</span>
                )}
              </Link>
            </div>

            <nav className="litaana-desktop-nav hidden-xs hidden-sm" aria-label="Main navigation">
              <ul className="litaana-nav-list">
                {navItems.map((item) => (
                  <li key={item.to}>
                    <NavLink
                      className={({ isActive }) =>
                        `litaana-nav-link${isActive ? ' litaana-nav-link--active' : ''}`
                      }
                      to={item.to}
                    >
                      {item.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </nav>

            <div className="litaana-mobile-header visible-xs visible-sm">
              <div className="litaana-mobile-header__top">
                <div className="logo-mobile">
                  <Link to="/">
                    {!logoError ? (
                      <img
                        id="litaana-header-logo-mobile"
                        src="images/newlogo.png"
                        alt="LITAANA"
                        className="litaana-logo-img litaana-logo-img--mobile"
                        onError={() => setLogoError(true)}
                      />
                    ) : (
                      <span className="litaana-logo-text litaana-logo-text--sm">LITAANA</span>
                    )}
                  </Link>
                </div>

                <div className="newnavbar">
                  <label
                    id="navlabel"
                    htmlFor="ackapa"
                    className="fa fa-navicon litaana-burger"
                    aria-label="Open menu"
                  />
                  <input type="checkbox" id="ackapa" />
                  <nav className="navnew" aria-label="Mobile navigation">
                    <ul className="navnewul">
                      <li className="navnewli">
                        <NavLink
                          end
                          className={({ isActive }) =>
                            `navnewa${isActive ? ' navnewa--active' : ''}`
                          }
                          to="/"
                          onClick={closeMobileMenu}
                        >
                          Home
                        </NavLink>
                      </li>
                      {navItems.map((item) => (
                        <li className="navnewli" key={item.to}>
                          <NavLink
                            className={({ isActive }) =>
                              `navnewa${isActive ? ' navnewa--active' : ''}`
                            }
                            to={item.to}
                            onClick={closeMobileMenu}
                          >
                            {item.label}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </nav>
                </div>
              </div>

              <button
                type="button"
                className="litaana-powered-by litaana-powered-by--mobile"
                onClick={() => setLhicOpen(true)}
              >
                <span className="litaana-powered-by__brand">LHIC</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      <LhicModal isOpen={lhicOpen} onClose={() => setLhicOpen(false)} />
    </div>
  )
}
